import { createSelector } from "reselect";

const selectUsersState = (state) => state.users;

const selectUsers = () => createSelector(selectUsersState, (usersState) => usersState.users);
const selectUsersFilter = () => createSelector(selectUsersState, (usersState) => usersState.filter);


export {
    selectUsers,
    selectUsersFilter
};
